module.exports = __webpack_public_path__ + "img/g13.499d9e3e.jpg";